import Toast from 'Toast'
import { logException } from 'utils/exceptionLogger'

import replaceInterpolationSymbols from './replaceInterpolationSymbols'

const translations = fetch('/translations?locale=' + window.locale_name, {
  credentials: 'include',
  mode: 'no-cors',
})
  .then((response) => response.json())
  .then((response: Record<string, string>) =>
    Object.fromEntries(
      Object.entries(response).flatMap(([key, value]) =>
        value ? [[key, replaceInterpolationSymbols(value, true)]] : []
      )
    )
  )
  .catch((e) => {
    logException(e as Error)

    Toast.error(
      'Something went wrong while fetching translations. Please try again later.'
    )

    return Promise.resolve(null)
  })

export default translations
